// extracted by mini-css-extract-plugin
export default {"wrap":"PageLoader_wrap__t6osh","spinner":"PageLoader_spinner__AspSb","spin":"PageLoader_spin__+CiyF"};